
import {initWebComponent} from "@/helpers/web-component-helper";
import {DragZoom} from "ol/interaction";
import {hideElementsBySelector, isVisibleBySelector, showElementsBySelector} from "@/helpers/element-helper.js";

const template = document.createElement('template');
template.innerHTML = `<footer-button-right data-title="Overzichtskaart" data-icon="fa fa-map-pin">`;

export class OlOverViewMapComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            window.overviewMapControl.setCollapsed(!window.overviewMapControl.getCollapsed())
        });
    }
}

